<template>
  <div v-if="displayedProducts.length > 0 && !$store.state.view.isLoading" class="products-grid">

    <carousel v-if="isCarousel" :perPage="5">
      <template v-for="product in displayedProducts">
        <slide :key="`${prefix}${product.id}`">
          <SimpleBox
            :product="product"
            :key="`${prefix}${product.id}`"
            :hideImage="hideImage"
            :hideName="hideName"
            :hideSKU="hideSKU"
            :additionalInfo="additionalInfo"
          />
          </slide>
      </template>
    </carousel>

    <template v-else="" v-for="product in displayedProducts">
      <SimpleBox
        :product="product"
        :key="`${prefix}${product.id}`"
        :hideImage="hideImage"
        :hideName="hideName"
        :hideSKU="hideSKU"
        :additionalInfo="additionalInfo"
      />
    </template>

  </div>
</template>

<script>
import SimpleBox from "./SimpleBox.vue";
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "ProductGrid",
  components: {
    SimpleBox,
    Carousel,
    Slide
  },
  props: {
    prefix: {
      type: String,
      default() {
        return "";
      }
    },
    displayedProducts: {
      type: Array,
      default() {
        return [];
      }
    },
    hideImage: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hideSKU: {
      type: Boolean,
      default() {
        return ws_vue_store.archive_product_sku === "0";
      }
    },
    additionalInfo: {
      type: String,
      default() {
        return '';
      }
    },
    isCarousel: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      translations: {
        productName: ws_vue_store.translations.product_name,
        productSKU: ws_vue_store.translations.product_SKU,
        productPrice: ws_vue_store.translations.product_price,
        other: ws_vue_store.translations.other,
        addToCart: ws_vue_store.translations.add_to_cart
      }
    };
  }, // data
  created() {}, // created
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
};
</script>

